<template>
    <form @submit.prevent="submitPrevent" id="form" name="outlet_information_form" autocomplete="off"
          ref="outlet_information_form" class="content-inner formValidation">
        <div ref="outlet_block">
            <div class="row">
                <div class="col-12"  v-if="!is_reviewing">
                    <div class="panel-sub-heading headingLarge">
                        <span class="h5 display-6 markedBottom bold">{{ lang('trading_details') }}</span>
                    </div>
                </div>
                <np-input  :no-wrapper="true" :id="'section'" :name="'section'" :type="'hidden'" model-value="OUTLET_INFORMATION"></np-input>
                <div class="col-lg-6 col-md-12 col-12" >
                    <div class="row" ref="block_outlet_details">
                        <div class="col-12">
                            <div class="panel-sub-heading headingSmall">
                                <span class="markedBottom">{{ lang('general_information') }}</span>
                                <span class="float-right float-end">
                                    <np-checkbox v-show="merchantHasTradeName"
                                        :name="'copy_business_trade_name'"
                                        :id="'copy_business_trade_name'"
                                        :no-wrapper="true"
                                        :description="lang('copy_business_trade_name')"
                                        @change="copyBusinessInfo($event, outlet)"
                                        ref="copy_to_trade_name"
                                        v-model="outlet.store_info_same_as_business_info">
                                    </np-checkbox>
                                </span>
                            </div>
                        </div>
                        <div class="col-12">
                            <np-input
                                :id="`trade_name`"
                                :name="`trade_name`"
                                :label="lang('trade_name')"
                                :maxlength="getTradeNameFieldLengthByIso3(getIso3FromCountryCode(baseCountryCode), 'max') "
                                :help-text="getTooltipText('trade_name_help_text')"
                                ref="trade_name"
                                :rules="['alpha_company']"
                                :no-wrapper="false"
                                v-model="outlet.trade_name">
                            </np-input>
                            <np-input
                                :id="`outlet_website`"
                                :name="`outlet_website`"
                                :label="lang('field_website')"
                                :help-text="getTooltipText('field_website_tooltip')"
                                :maxlength="512"
                                :required="outlet.sales_internet_perc > 0"
                                :check_config="false"
                                :rules="['valid_url']"
                                ref="outlet_website"
                                :no-wrapper="false"
                                v-model="outlet.outlet_website">
                            </np-input>
<!--                          <np-select2-->
<!--                              :id="'chain_number'"-->
<!--                              ref="chain_number"-->
<!--                              :name="'chain_number'"-->
<!--                              :label="lang('chain_number')"-->
<!--                              :parameters="parameters.CHAIN_NUMBER"-->
<!--                              v-model="outlet.chain_number">-->
<!--                          </np-select2>-->
                            <np-textarea
                                :id="`prod_serv_sold`"
                                :name="`prod_serv_sold`"
                                :label="lang('field_product_and_services_sold')"
                                :placeholder="lang('field_product_and_services_sold')"
                                :required="true"
                                :rules="['no_trailing_space']"
                                :minlength="3"
                                :maxlength="255"
                                ref="prod_serv_sold"
                                :help-text="getTooltipText('field_product_and_services_sold')"
                                v-model="outlet.prod_serv_sold">
                            </np-textarea>
                        </div>
                    </div>
                    <div class="row" ref="block_transactions" >
                        <div class="col-12" v-show="show_block_transactions_heading || outletIsEcom || isLargeMoto">
                            <div class="panel-sub-heading headingSmall">
                                <span class="markedBottom">{{ lang('transactions') }}</span>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row" v-if="!outletIsEcom || isBlendedMid">

                                <div class="col-lg-6 col-md-6 col-12">
                                    <np-input
                                            :name="'sales_ftf_perc'"
                                            :id="'sales_ftf_perc'"
                                            :label="lang('field_card_present_transactions')"
                                            ref="sales_ftf_perc"
                                            :rules="['numeric', 'together_100_percent_group', {'percent_group': 'transactions'}]"
                                            :maxlength="3"
                                            :min="0"
                                            :max="100"
                                            :no-wrapper="false"
                                            v-model="outlet.sales_ftf_perc">
                                        <template #addon>
                                            <span>%</span>
                                        </template>
                                    </np-input>
                                </div>
                                <div class="col-lg-6 col-md-6 col-12">
                                    <np-input
                                            :name="'sales_moto_perc'"
                                            :id="'sales_moto_perc'"
                                            :label="lang('field_moto_transactions')"
                                            ref="sales_moto_perc"
                                            :rules="['numeric', 'together_100_percent_group', {'percent_group': 'transactions'}]"
                                            :maxlength="3"
                                            :min="0"
                                            :max="100"
                                            :no-wrapper="false"
                                            v-model="outlet.sales_moto_perc">
                                        <template #addon>
                                        <span>%</span>
                                        </template>
                                    </np-input>
                                </div>
                                <div class="col-lg-6 col-md-6 col-12" v-if="isBlendedMid">
                                    <np-input
                                            :name="'sales_internet_perc'"
                                            :id="'sales_internet_perc'"
                                            :label="lang('field_internet_transactions')"
                                            ref="sales_internet_perc"
                                            :rules="['numeric', 'together_100_percent_group', {'percent_group': 'transactions'}]"
                                            :maxlength="3"
                                            :min="0"
                                            :max="100"
                                            :no-wrapper="false"
                                            v-model="outlet.sales_internet_perc">
                                        <template #addon>
                                            <span>%</span>
                                        </template>
                                    </np-input>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row" v-if="outletIsEcom || isLargeMoto">
                                <div class="col-lg-6 col-md-6 col-12">
                                    <np-radios ref="cvv2_used"
                                               :name="'cvv2_used'"
                                               :id="'cvv2_used'"
                                               :help-text="getTooltipText('cvv2_help_text')"
                                               :label="lang('cvv2_used')"
                                               :options="parameters.YES_NO_OPTIONS"
                                               :mode="'co-join'"
                                               v-model="outlet.cvv2_used">
                                    </np-radios>
                                </div>
                                <div class="col-lg-6 col-md-6 col-12">
                                    <np-radios ref="recurring_flag"
                                               :name="'recurring_flag'"
                                               :id="'recurring_flag'"
                                               :label="lang('field_recurring_flag')"
                                               :options="parameters.YES_NO_OPTIONS"
                                               :mode="'co-join'"
                                               v-model="outlet.recurring_flag">
                                    </np-radios>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div ref="block_ecom_payment_methods" class="row">
                        <template v-if="can_process_german_ecom_payment">
                            <div class="col-12">
                                <div class="panel-sub-heading headingSmall">
                                    <span class="markedBottom">{{ lang('ecom_payment_methods') }}</span>
                                </div>
                            </div>
                            <div class="col-6">
                                <np-select2-multi
                                    ref="ecom_payment_method_default"
                                    :id="'ecom_payment_method_default'"
                                    :name="'ecom_payment_method_default'"
                                    :label="lang('ecom_payment_methods_default')"
                                    :placeholder="lang('ecom_payment_methods_default')"
                                    :multi="true"
                                    @input="(e) => updateEcomPaymentMethod('standard_methods_data', e)"
                                    :parameters="parameters['ECOM_PAYMENT_METHOD_STANDARD']"
                                    v-model="outlet.ecom_payment_methods.selected_standard_methods">
                                </np-select2-multi>
                                <div class="row">
                                    <div class="col-12" v-if="is_ecom_loading.standard_methods_data">
                                        <np-notice :notice="lang('loading')"></np-notice>
                                    </div>
                                        <template v-else>
                                            <template  v-for="(method_value, idx) in outlet.ecom_payment_methods.standard_methods_data"  :key="'ecom_payment_method_'+idx">
                                            <ecom-payment-method
                                                                 is_editing
                                                                 parameter="ECOM_PAYMENT_METHOD_STANDARD"
                                                                 :ecom_payment_method="method_value"
                                                                 :formatter="formatEcomPaymentText">

                                            </ecom-payment-method>
                                            </template>
                                        </template>
                                </div>
                            </div>
                            <div class="col-6">
                                <np-select2-multi
                                    ref="ecom_payment_method_pro"
                                    :id="'ecom_payment_method_pro'"
                                    :name="'ecom_payment_method_pro'"
                                    :label="lang('ecom_payment_methods_pro')"
                                    :placeholder="lang('ecom_payment_methods_pro')"
                                    :multi="true"
                                    @input="(e) => updateEcomPaymentMethod('pro_methods_data', e)"
                                    :parameters="parameters['ECOM_PAYMENT_METHOD_PRO']"
                                    v-model="outlet.ecom_payment_methods.selected_pro_methods">
                                </np-select2-multi>
                                <div class="row">
                                    <div class="col-12" v-if="is_ecom_loading.pro_methods_data">
                                        <np-notice :notice="lang('loading')"></np-notice>
                                    </div>
                                    <template v-else>
                                        <template  v-for="(method_value, idx) in outlet.ecom_payment_methods.pro_methods_data" :key="'ecom_payment_method_pro_'+idx">
                                            <ecom-payment-method  is_editing
                                                                  parameter="ECOM_PAYMENT_METHOD_PRO"
                                                                  :ecom_payment_method="method_value"
                                                                  :formatter="formatEcomPaymentText">

                                            </ecom-payment-method>
                                        </template>
                                    </template>

                                </div>
                            </div>
                            <div class="col-6">
                                <np-select2-multi
                                    ref="ecom_payment_method_options"
                                    :id="'ecom_payment_method_options'"
                                    :name="'ecom_payment_method_options'"
                                    :label="lang('ecom_payment_methods_options')"
                                    :placeholder="lang('ecom_payment_methods_options')"
                                    :multi="true"
                                    :parameters="parameters['ECOM_PAYMENT_METHOD_OPTIONS']"
                                    v-model="outlet.ecom_payment_methods.option_methods_data">
                                </np-select2-multi>
                            </div>
                        </template>
                    </div>
                    <div class="row" ref="block_deposit">
                        <div class="col-12">
                            <div class="panel-sub-heading headingSmall">
                                <span class="markedBottom">{{ lang('deposit') }}</span>
                            </div>
                        </div>
                        <div class="col-12">
                            <np-radios
                                ref="deposit_flag"
                                :label="lang('deposit_required')"
                                :id="'deposit_flag'"
                                :name="'deposit_flag'"
                                mode="co-join"
                                :options="parameters.YES_NO_OPTIONS"
                                v-model="outlet.deposit_flag">
                            </np-radios>
                        </div>
                        <div class="col-12" v-show="depositRequired">
                            <np-input
                                :name="'deposit_perc_transaction_value'"
                                :id="'deposit_perc_transaction_value'"
                                :label="lang('deposit_perc_transaction_value')"
                                :rules="['is_natural', {'less_than_equal' : '100'}]"
                                :maxlength="3"
                                :min="0"
                                :no-wrapper="false"
                                :addon-on-left="false"
                                ref="deposit_perc_transaction_value"
                                v-model="outlet.deposit_perc_transaction_value">
                                <template #addon>
                                    <span>%</span>
                                </template>
                            </np-input>
                            <np-input
                                :name="'deposit_total_annual_turnover'"
                                :id="'deposit_total_annual_turnover'"
                                :label="lang('deposit_perc_annual_turnover')"
                                :rules="['is_natural', {'less_than_equal' : '100'}]"
                                :min="0"
                                maxlength="3"
                                :no-wrapper="false"
                                :addon-on-left="false"
                                ref="deposit_total_annual_turnover"
                                v-model="outlet.deposit_total_annual_turnover">
                                <template #addon>
                                    <span>%</span>
                                </template>
                            </np-input>

                            <np-input
                                :name="'deposit_avg_time'"
                                :id="'deposit_avg_time'"
                                :label="lang('field_deposit_avg_time')"
                                :no-wrapper="false"
                                :rules="['integer']"
                                :check_config="false"
                                :required="depositRequired"
                                :max="365"
                                :maxlength="3"
                                ref="deposit_avg_time"
                                v-model="outlet.deposit_avg_time">
                                <template #addon>
                                    <span>{{ lang('days') }}</span>
                                </template>
                            </np-input>
                            <np-input
                                :name="'deposit_balance_settle_time'"
                                :id="'deposit_balance_settle_time'"
                                :label="lang('deposit_balance_settle_time')"
                                :no-wrapper="false"
                                :rules="['integer']"
                                :max="365"
                                :maxlength="3"
                                ref="deposit_balance_settle_time"
                                v-model="outlet.deposit_balance_settle_time">
                                <template #addon>
                                    <span>{{ lang('days') }}</span>
                                </template>
                            </np-input>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 col-12">
                    <div  class="row" ref="block_full_pre_payment">
                        <div class="col-12">
                            <div class="panel-sub-heading headingSmall">
                                <span class="markedBottom">{{ lang('full_pre_payment') }}</span>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <np-radios
                                ref="has_full_pmnt_bef_del"
                                :label="lang('field_full_payment_before_delivery')"
                                :id="'has_full_pmnt_bef_del'"
                                :name="'has_full_pmnt_bef_del'"
                                mode="co-join"
                                :options="parameters.YES_NO_OPTIONS"
                                v-model="outlet.has_full_pmnt_bef_del">
                            </np-radios>
                            <np-input v-show="paymentBeforeDeliveryAccepted"
                                :name="'delivery_timeframe'"
                                :id="'delivery_timeframe'"
                                :label="lang('field_avg_delivery_time')"
                                :rules="['numeric']"
                                :maxlength="3"
                                :min="1"
                                :max="365"
                                ref="delivery_timeframe"
                                :no-wrapper="false"
                                :check_config="false"
                                      :required="paymentBeforeDeliveryAccepted"
                                :addon-on-left="false"
                                v-model="outlet.delivery_timeframe">
                                <template #addon>
                                    <span>{{ lang('days') }}</span>
                                </template>
                            </np-input>
                            <np-input
                                v-show="paymentBeforeDeliveryAccepted"
                                :name="'perc_annual_upfront_of_turnover'"
                                :id="'perc_annual_upfront_of_turnover'"
                                :label="lang('perc_annual_upfront_of_turnover')"
                                :rules="['numeric']"
                                :maxlength="3"
                                :min="1"
                                :max="100"
                                ref="perc_annual_upfront_of_turnover"
                                :check_config="false"
                                :required="paymentBeforeDeliveryAccepted"
                                :no-wrapper="false"
                                :addon-on-left="false"
                                v-model="outlet.perc_annual_upfront_of_turnover">
                                <template #addon>
                                    <span>%</span>
                                </template>
                            </np-input>
                        </div>
                    </div>
                    <div class="row" ref="block_store_contact_information">
                        <div class="col-12">
                            <div class="panel-sub-heading headingSmall">
                                <span class="markedBottom">{{ lang('store_contact') }}</span>
<!--                                <span class="float-right float-end">-->
<!--                                    <np-checkbox-->
<!--                                            :name="'trading_contact_as_business_contact'"-->
<!--                                            :id="'trading_contact_as_business_contact'"-->
<!--                                            :no-wrapper="true"-->
<!--                                            :description="lang('field_same_as_business_contact')"-->
<!--                                            @change="copyBusinessContact($event, outlet.trading)"-->
<!--                                            ref="copy_to_store_contact"-->
<!--                                            v-model="outlet.store_contact_same_as_business_contact">-->
<!--                                    </np-checkbox>-->
<!--                                </span>-->
                            </div>
                        </div>
<!--                        <div class="col-12" v-if="outlet.store_contact_same_as_business_contact === '1'">-->
<!--                            <p v-html="formatTradeContact(outlet.trading)"></p>-->
<!--                        </div>-->
                        <div class="col-12">
                            <np-checkbox
                                :name="'trading_contact_as_business_contact'"
                                :id="'trading_contact_as_business_contact'"
                                :no-wrapper="true"
                                :description="lang('field_same_as_business_contact')"
                                @change="copyBusinessContact($event, outlet.trading)"
                                ref="copy_to_store_contact"
                                v-model="outlet.store_contact_same_as_business_contact">
                            </np-checkbox>
                            <div class="row">
                                <div class="col-lg-7 col-md-8 col-sm-12">
                                    <np-radios ref="store_contact_title"
                                            :name="'trading_contact_title'"
                                            :id="'trading_contact_title'"
                                            :label="lang('field_title')"
                                            :options="primeTitles"
                                            :mode="'separate'"
                                            v-model="outlet.trading.contact_title">
                                    </np-radios>
                                </div>
                                <div class="col-lg-5 col-md-4 col-sm-12">
                                    <np-select2 v-if="outlet.trading.contact_title === 'other'"
                                                ref="store_contact_title"
                                                :name="'other_contact_title'"
                                                :id="'other_contact_title'"
                                                :placeholder="lang('field_title')"
                                                :parameters="otherTitles"
                                                :required="true"
                                                :rules="['required']"
                                                :no-wrapper="false"
                                                v-model="outlet.trading.other_contact_title">
                                    </np-select2>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-12">
                                    <np-input ref="store_contact_first_name"
                                            :name="'trading_contact_first_name'"
                                            :id="'trading_contact_first_name'"
                                            :label="lang('field_first_name')"
                                            :no-wrapper="false"
                                            :rules="['alpha_name']"
                                            :maxlength="getFirstNameMaxLengthByIso3('max')"
                                            v-model="outlet.trading.contact_first_name">
                                    </np-input>
                                </div>
                                <div class="col-lg-6 col-md-6 col-12">
                                    <np-input
                                        :name="'trading_contact_second_name'"
                                        :id="'trading_contact_second_name'"
                                        :label="lang('field_middle_name')"
                                        :no-wrapper="false"
                                        :rules="['alpha_name']"
                                        :maxlength="25"
                                        :required="false"
                                        ref="store_contact_second_name"
                                        v-model="outlet.trading.contact_second_name">
                                    </np-input>
                                </div>
                                <div class="col-lg-6 col-md-6 col-12">
                                    <np-input
                                            :name="'contact_last_name'"
                                            :id="'contact_last_name'"
                                            :label="lang('field_last_name')"
                                            :no-wrapper="false"
                                            :rules="['alpha_name']"
                                            :maxlength="25"
                                            ref="store_contact_last_name"
                                            v-model="outlet.trading.contact_last_name">
                                    </np-input>
                                </div>
                            </div>
                            <np-input
                                    :name="'trading_contact_email_address'"
                                    :id="'trading_contact_email_address'"
                                    :label="lang('field_email')"
                                    :no-wrapper="false"
                                    :rules="['valid_email']"
                                    :maxlength="50"
                                    ref="store_email_address"
                                    v-model="outlet.trading.email_address">
                            </np-input>
                            <div class="row compactInputFormat" ref="store_contact_phone">
                                <div class="col-12 col-md-12">
                                    <label>{{lang('phone')}}</label>
                                </div>
                              <div class="input-group">
                                <div class="col-5">
                                    <np-select2
                                            :name="'trading_contact_ent_telephone_code'"
                                            :id="'trading_contact_ent_telephone_code'"
                                            :placeholder="lang('phone_code')"
                                            :no-wrapper="true"
                                            :mode="`phone`"
                                            :required="true"
                                            ref="store_contact_phone_code"
                                            :parameters="parameters.PHONE_CODES"
                                            v-model="outlet.trading.ent_telephone_code">
                                    </np-select2>
                                </div>
                                <div class="col-7">
                                    <np-phone ref="store_contact_phone_no"
                                              :name="'trading_contact_telephone_number'"
                                              :id="'trading_contact_telephone_number'"
                                              :no-wrapper="true"
                                              :label="lang('phone_number')"
                                              :rules="['numeric', 'required', 'phone_no_leading_zero']"
                                              :maxlength=" getPhoneNoMaxLengthByIso3( getIso3FromPhoneCode( outlet.trading.ent_telephone_code ) ) "
                                              :minlength=" getPhoneNoMinLengthByIso3( getIso3FromPhoneCode( outlet.trading.ent_telephone_code ) ) "
                                              :phone-code="outlet.trading.ent_telephone_code"
                                              v-model="outlet.trading.telephone_number">
                                    </np-phone>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" ref="block_store_address">
                        <div class="col-12">
                            <div class="panel-sub-heading headingSmall">
                                <span class="markedBottom">{{ lang('store_address') }}</span>
                            </div>
                        </div>
                        <div class="col-12">
                            <np-checkbox
                                :name="'trading_store_as_registered_address'"
                                :id="'trading_store_as_registered_address'"
                                :no-wrapper="true"
                                :description="lang('field_same_as_registered_address')"
                                @change="copyRegisteredAddress($event, outlet.trading)"
                                ref="copy_to_store_address"
                                v-model="outlet.store_address_same_as_registered_address">
                            </np-checkbox>
                        </div>
                        <div class="col-12" v-if="outlet.store_address_same_as_registered_address === '1'">
                            <p v-html="formatAddress(outlet.trading)"></p>
                        </div>
                        <div class="col-12" v-else>
                            <div class="row">
                                <div class="col-lg-4 col-md-4">
                                    <np-input
                                        :id="`store_house_number`"
                                        :name="`store_house_number`"
                                        ref="store_address_house_number"
                                        :label="lang('building_number')"
                                        :rules="['alpha_numeric_slash']"
                                        :maxlength="20"
                                        :no-wrapper="false"
                                        :required="false"
                                        v-model="outlet.trading.house_number">
                                    </np-input>
                                </div>
                                <div class="col-lg-8 col-md-8">
                                    <np-postcode-search
                                        ref="store_address_zip_code"
                                        :name="'store_address_zip_code'"
                                        :id="'store_address_zip_code'"
                                        :label="lang('post_code')"
                                        :required="true"
                                        :rules="getPostCodeRules()"
                                        :minlength="getPostCodeFieldLengthByIso3(getIso3FromCountryCode(baseCountryCode), 'min')"
                                        :maxlength="getPostCodeFieldLengthByIso3(getIso3FromCountryCode(baseCountryCode), 'max')"
                                        :iso3=" getIso3FromCountryCode( baseCountryCode ) "
                                        v-model="outlet.trading.zip_code"
                                        :reference="merchantReference"
                                        @input="changeTradingAddress"
                                        @empty-address="allowManualEdit"
                                        @address-selected="updateCompanyAddress($event, outlet.trading)">
                                    </np-postcode-search>
                                </div>
                                <div class="col-md-12 mt-3"
                                     v-if="outlet.trading.zip_code === '' && !edit_address && outlet.trading.street_line_1 === ''">
                                    <div class="card card--address--reminder">
                                        <div class="card-body">
                                            <span class="card-text">{{lang('please_search_postcode_for_details')}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 mt-3" v-if="!edit_address">
                                    <div v-if="outlet.trading.street_line_1 !== ''">
                                        <div class="card card--address">
                                            <div class="card-body">
                                        <span class="card-text"
                                              v-html="formatAddress(outlet.trading, true)"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="button" @click="editAddress" class="btn btn-primary float-right float-end">
                                        {{lang('enter_address_manually')}}
                                    </button>
                                </div>
                                <div class="col-12" v-show="edit_address">
                                    <np-input
                                        :name="'store_address_house_name'"
                                        :id="'store_address_house_name'"
                                        :label="lang('building_name')"
                                        :no-wrapper="false"
                                        :required="false"
                                        ref="store_address_house_name"
                                        :maxlength="getHouseNameFieldLength('max')"
                                        v-model="outlet.trading.house_name">
                                    </np-input>
                                    <div class="row">
                                        <div class="col-md-4 col-12">
                                            <np-input
                                                :id="`store_address_flat_number`"
                                                :name="`store_address_flat_number`"
                                                ref="store_address_flat_number"
                                                :label="lang('field_flat_number')"
                                                :rules="['alpha_numeric_space']"
                                                :maxlength="getFlatNumberFieldLength('max')"
                                                :no-wrapper="false"
                                                :required="false"
                                                v-model="outlet.trading.flat_number">
                                            </np-input>
                                        </div>
                                        <div class="col-md-8 col-12">
                                            <np-input
                                                :id="`store_address_flat_name`"
                                                :name="`store_address_flat_name`"
                                                ref="store_address_flat_name"
                                                :label="lang('field_flat_name')"
                                                :rules="['alpha_numeric_space']"
                                                :no-wrapper="false"
                                                :required="false"
                                                v-model="outlet.trading.flat_name">
                                            </np-input>
                                        </div>
                                    </div>
                                    <np-input
                                        :name="'store_address_street_line_1'"
                                        :id="'store_address_street_line_1'"
                                        :label="lang('field_street')"
                                        :no-wrapper="false"
                                        :rules="['alpha_space_dot']"
                                        :maxlength="getStreetNameFieldLength('max')"
                                        ref="store_address_street_line_1"
                                        v-model="outlet.trading.street_line_1">
                                    </np-input>
                                    <np-input
                                        :name="'store_address_city'"
                                        :id="'store_address_city'"
                                        :label="lang('field_town_city')"
                                        :no-wrapper="false"
                                        :rules="['valid_city_town']"
                                        ref="store_address_city"
                                        :maxlength="getCityFieldLength('max')"
                                        v-model="outlet.trading.city">
                                    </np-input>
                                    <div v-if="outlet.trading.country_code === '840'">
                                        <np-select2
                                            :name="'store_address_county_code'"
                                            :id="'store_address_county_code'"
                                            :label="lang('state')"
                                            :no-wrapper="false"
                                            :required="false"
                                            ref="store_address_county_code"
                                            :parameters="parameters.STATES_PARAM"
                                            v-model="outlet.trading.county_code">
                                        </np-select2>
                                    </div>
                                    <div v-else>
                                        <np-input
                                            :name="'store_address_county_code'"
                                            :id="'store_address_county_code'"
                                            :label="lang('field_county_state')"
                                            :no-wrapper="false"
                                            :required="false"
                                            :rules="['alpha_space_dot']"
                                            v-country-dependent="[outlet.trading.country_code, 'county_code']"
                                            ref="store_address_county_code"
                                            v-model="outlet.trading.county_code">
                                        </np-input>
                                    </div>
                                    <np-select2
                                        :name="'store_address_country_code'"
                                        :id="'store_address_country_code'"
                                        :mode="`country`"
                                        :label="lang('country')"
                                        :parameters="country_code_params"
                                        :no-wrapper="false"
                                        ref="store_address_country_code"
                                        v-model="outlet.trading.country_code">
                                    </np-select2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" ref="block_finder_store_address">
                        <div class="col-12">
                            <div class="panel-sub-heading headingSmall">
                                <span class="markedBottom">{{ lang('store_address') }}</span>
                            </div>
                        </div>
                        <div class="col-12">
                            <np-checkbox
                                    :name="'trading_store_as_registered_address'"
                                    :id="'finder_trading_store_as_registered_address'"
                                    ref="finder_copy_to_store_address"
                                    :no-wrapper="true"
                                    :description="lang('field_same_as_registered_address')"
                                    @change="copyRegisteredAddress($event, outlet.trading)"
                                    v-model="outlet.store_address_same_as_registered_address">
                            </np-checkbox>
                        </div>
                        <div class="col-12" v-if="outlet.store_address_same_as_registered_address === '1'">
                            <p v-html="formatAddress(outlet.trading)"></p>
                        </div>
                        <div class="col-12" v-else>
                            <div class="row">
                                <div class="col-lg-12 col-md-12">
                                    <np-postcode-search
                                            :id="`address_finder`"
                                            :name="`address_finder`"
                                            ref="address_finder"
                                            :label="lang('address_or_postcode_search')"
                                            :required="false"
                                            :maxlength="50"
                                            :rules="['alpha_address_finder']"
                                            :reference="merchantReference"
                                            :postcode_only="false"
                                            :iso3="getIso3FromCountryCode(baseCountryCode)"
                                            v-model="outlet.trading.address_finder"
                                            @input="changeAddressFinderTradingAddress"
                                            @empty-address="allowManualEdit"
                                            @address-selected="updateCompanyAddress($event, outlet.trading, true)"
                                    ></np-postcode-search>
                                </div>
                                <div class="col-md-12 mt-3"
                                     v-if="outlet.trading.address_finder === '' && !edit_address && outlet.trading.street_line_1 === ''">
                                    <div class="card card--address--reminder">
                                        <div class="card-body">
                                            <span class="card-text">{{lang('please_search_postcode_or_address_for_details')}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 mt-3" v-if="!edit_address">
                                    <div v-if="outlet.trading.street_line_1 !== ''">
                                        <div class="card card--address">
                                            <div class="card-body">
                                        <span class="card-text"
                                              v-html="formatAddress(outlet.trading, true)"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="button" @click="editAddress" class="btn btn-primary float-right float-end">
                                        {{lang('enter_address_manually')}}
                                    </button>
                                </div>
                                <div class="col-12" v-show="edit_address">
                                    <div class="row" v-for="address_row in getStoreAddressFinderStructureByIso3(getIso3FromCountryCode(allianceCountry))">
                                        <template v-for="address_field in address_row">
                                            <div :class="address_field[1]" v-if="address_field[0] === 'finder_store_address_house_number'">
                                                <np-input
                                                        :id="`finder_store_address_house_number`"
                                                        :name="`store_house_number`"
                                                        :label="getHouseNumberLabelFromCountryCode(allianceCountry)"
                                                        :rules="['alpha_numeric_slash']"
                                                        :maxlength="20"
                                                        ref="finder_store_address_house_number"
                                                        :no-wrapper="false"
                                                        :required="false"
                                                        v-model="outlet.trading.house_number">
                                                </np-input>
                                            </div>
                                            <div :class="address_field[1]" v-if="address_field[0] === 'finder_store_address_house_name'">
                                                <np-input
                                                        :name="'store_address_house_name'"
                                                        :id="'finder_store_address_house_name'"
                                                        :label="getHouseNameLabelFromCountryCode(allianceCountry)"
                                                        :no-wrapper="false"
                                                        :required="false"
                                                        ref="finder_store_address_house_name"
                                                        :maxlength="getHouseNameFieldLength('max')"
                                                        v-model="outlet.trading.house_name">
                                                </np-input>
                                            </div>
                                            <div :class="address_field[1]" v-if="address_field[0] === 'finder_store_address_flat_number'" ref="finder_store_address_flat_number">
                                                <np-input
                                                        :id="`finder_store_address_flat_number`"
                                                        :name="`store_address_flat_number`"
                                                        :label="lang('field_flat_number')"
                                                        :rules="['alpha_numeric_space']"
                                                        :maxlength="getFlatNumberFieldLength('max')"
                                                        :no-wrapper="false"
                                                        :required="false"
                                                        v-model="outlet.trading.flat_number">
                                                </np-input>
                                            </div>
                                            <div :class="address_field[1]" v-if="address_field[0] === 'finder_store_address_flat_name'" ref="finder_store_address_flat_name">
                                                <np-input
                                                        :id="`finder_store_address_flat_name`"
                                                        :name="`store_address_flat_name`"
                                                        :label="lang('field_flat_name')"
                                                        :rules="['alpha_numeric_space']"
                                                        :no-wrapper="false"
                                                        :required="false"
                                                        v-model="outlet.trading.flat_name">
                                                </np-input>
                                            </div>
                                            <div :class="address_field[1]" v-if="address_field[0] === 'finder_store_address_street_line_1'">
                                                <np-input
                                                        :name="'store_address_street_line_1'"
                                                        :id="'finder_store_address_street_line_1'"
                                                        :label="getStreetLabelFromCountryCode(allianceCountry)"
                                                        :no-wrapper="false"
                                                        ref="finder_store_address_street_line_1"
                                                        :rules="['alpha_space_dot']"
                                                        :maxlength="getStreetNameFieldLength('max')"
                                                        v-model="outlet.trading.street_line_1">
                                                </np-input>
                                            </div>
                                            <div :class="address_field[1]" v-if="address_field[0] === 'finder_store_address_city'">
                                                <np-input
                                                        :name="'store_address_city'"
                                                        :id="'finder_store_address_city'"
                                                        :label="getCityLabelFromCountryCode(allianceCountry)"
                                                        :no-wrapper="false"
                                                        :rules="['valid_city_town']"
                                                        ref="finder_store_address_city"
                                                        :maxlength="getCityFieldLength('max')"
                                                        v-model="outlet.trading.city">
                                                </np-input>
                                            </div>
                                            <div :class="address_field[1]" v-if="address_field[0] === 'finder_store_address_county_code'" ref="finder_store_address_county_code">
                                                <np-select2
                                                        v-if="outlet.trading.country_code === '840'"
                                                        :name="'store_address_county_code'"
                                                        :id="'finder_store_address_county_code'"
                                                        :label="lang('state')"
                                                        :no-wrapper="false"
                                                        :required="false"
                                                        :parameters="parameters.STATES_PARAM"
                                                        v-model="outlet.trading.county_code">
                                                </np-select2>
                                                <np-input
                                                        v-else
                                                        :name="'store_address_county_code'"
                                                        :id="'finder_store_address_county_code'"
                                                        :label="lang('field_county_state')"
                                                        :no-wrapper="false"
                                                        :required="false"
                                                        :rules="['alpha_space_dot']"
                                                        v-country-dependent="[outlet.trading.country_code, 'county_code']"
                                                        v-model="outlet.trading.county_code">
                                                </np-input>
                                            </div>
                                            <div :class="address_field[1]" v-if="address_field[0] === 'finder_store_address_country_code'" >
                                                <np-select2
                                                        :name="'store_address_country_code'"
                                                        :id="'finder_store_address_country_code'"
                                                        :mode="`country`"
                                                        :label="lang('country')"
                                                        :parameters="country_code_params"
                                                        :no-wrapper="false"
                                                        ref="finder_store_address_country_code"
                                                        v-model="outlet.trading.country_code">
                                                </np-select2>
                                            </div>
                                            <div :class="address_field[1]" v-if="address_field[0] === 'finder_store_address_zip_code'">
                                                <np-input
                                                        :id="`finder_store_address_zip_code`"
                                                        :name="`store_address_zip_code`"
                                                        :label="lang('post_code')"
                                                        :required="true"
                                                        ref="finder_store_address_zip_code"
                                                        :rules="getPostCodeRules([{country_postcode_validator : outlet.trading.country_code}])"
                                                        :no-wrapper="false"
                                                        :minlength="getPostCodeFieldLengthByIso3(getMerchantCountryCode(outlet.trading.country_code), 'min')"
                                                        :maxlength="getPostCodeFieldLengthByIso3(getMerchantCountryCode(outlet.trading.country_code), 'max')"
                                                        v-model="outlet.trading.zip_code">
                                                </np-input>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4" style="border-top: 1px solid #b2c6d0" v-if="is_reviewing && isOpenApplication">
            <div class="col-12">
                <div class="my-3">
                    <a class="btn btn-default" @click="saveOutlet"> {{lang('save')}}</a>
                </div>
            </div>
        </div>
        <div class="row mt-4" v-else-if="!is_reviewing" style="border-top: 1px solid #b2c6d0">
            <div class="col-12">
                <div class="my-3">
                    <button type="button" class="btn btn-danger me-1" @click="goBack"> {{lang('go_back')}}</button>
                    <button type="button" class="btn btn-default me-1" @click="doContinue"> {{lang('continue')}}</button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import utilMixin from "../../../utils/mixins";
    import applicationMixin from "../../../utils/application-mixin";
    import {
        NPCheckBox,
        NPCompanySearch,
        NPDatePicker,
        NPInput,
        NPModal,
        NPNotice,
        NPPhone,
        NPPostcodeSearch,
        NPRadios,
        NPResponsive,
        NPSelect2,
        NPSelect2Multi,
        NPSkeleton,
        NPTextArea,
        NPVat
    } from "netpify/components";
    import {Contact} from "../../../entities";
    import * as types from "../../../stores/constants";
    import {defaultCountry} from "../../../entities/default";
    import EcomPaymentMethod from "../../../components/ecom-payment-method.vue"
    import useModuleStore from "../../../stores";

    export default {
        name: "TradingDetails",
        mixins:[utilMixin, applicationMixin],
        components: {
            'np-modal': NPModal,
            'np-textarea': NPTextArea,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-checkbox': NPCheckBox,
            'np-date-picker': NPDatePicker,
            'np-select2': NPSelect2,
            'np-company-search': NPCompanySearch,
            'np-postcode-search': NPPostcodeSearch,
            'np-responsive': NPResponsive,
            'np-vat': NPVat,
            'np-phone': NPPhone,
            'np-skeleton': NPSkeleton,
            'np-select2-multi': NPSelect2Multi,
            'np-notice': NPNotice,
            'ecom-payment-method': EcomPaymentMethod
        },
        props: {
            is_reviewing: {
                default: false,
                type: Boolean,
            }
        },
        data() {
            return {
                // outlet: new Outlet(),
                outlet_changed: false,
                copy_deposit_account: '',
                shipping_options_params: [
                    {
                        label: this.lang('select_equipment_to_this_store'),
                        value: '0',
                    },
                    {
                        label: this.lang('ship_to_different_address'),
                        value: '1'
                    }
                ],
                page_config_template: 'SelfTradingInformation',
                abortRouteLeave: false,
                app_default_param: {
                    COUNTRY_CODE: "country_code",
                    ENTITY_BLOCK_BUSINESS: "BUSINESS",
                    ENTITY_BLOCK_ALL_OUTLET: "ALL_OUTLET",
                    ENTITY_BLOCK_MAIN_OUTLET: "MAIN_OUTLET",
                },
                country_code_params: [],
                store_address_finder_structure: {
                    'SWE': [
                        [['finder_store_address_street_line_1', 'col-lg-12 col-md-12']],
                        [['finder_store_address_house_number', 'col-lg-4 col-md-4'], ['finder_store_address_house_name', 'col-lg-8 col-md-8']],
                        [['finder_store_address_flat_number', 'col-md-4 col-12'], ['finder_store_address_flat_name', 'col-md-8 col-12']],
                        [['finder_store_address_zip_code', 'col-lg-12 col-md-12']],
                        [['finder_store_address_city', 'col-lg-12 col-md-12']],
                        [['finder_store_address_county_code', 'col-lg-12 col-md-12']],
                        [['finder_store_address_country_code', 'col-lg-12 col-md-12']],
                    ],
                    'NOR': [
                        [['finder_store_address_street_line_1', 'col-lg-12 col-md-12']],
                        [['finder_store_address_house_number', 'col-lg-4 col-md-4'], ['finder_store_address_house_name', 'col-lg-8 col-md-8']],
                        [['finder_store_address_flat_number', 'col-md-4 col-12'], ['finder_store_address_flat_name', 'col-md-8 col-12']],
                        [['finder_store_address_zip_code', 'col-lg-12 col-md-12']],
                        [['finder_store_address_city', 'col-lg-12 col-md-12']],
                        [['finder_store_address_county_code', 'col-lg-12 col-md-12']],
                        [['finder_store_address_country_code', 'col-lg-12 col-md-12']],
                    ],
                    'DEU': [
                        [['finder_store_address_street_line_1', 'col-lg-8 col-md-8'], ['finder_store_address_house_number', 'col-lg-4 col-md-4']],
                        [['finder_store_address_zip_code', 'col-lg-8 col-md-8'], ['finder_store_address_city', 'col-lg-4 col-md-4']],
                        [['finder_store_address_country_code', 'col-lg-12 col-md-12']],
                    ],
                    default: [
                        [['finder_store_address_house_number', 'col-lg-4 col-md-4'], ['finder_store_address_house_name', 'col-lg-8 col-md-8']],
                        [['finder_store_address_flat_number', 'col-md-4 col-12'], ['finder_store_address_flat_name', 'col-md-8 col-12']],
                        [['finder_store_address_street_line_1', 'col-lg-12 col-md-12']],
                        [['finder_store_address_city', 'col-lg-12 col-md-12']],
                        [['finder_store_address_county_code', 'col-lg-12 col-md-12']],
                        [['finder_store_address_country_code', 'col-lg-12 col-md-12']],
                        [['finder_store_address_zip_code', 'col-lg-12 col-md-12']],
                    ]
                },
                show_block_transactions_heading: false,
                is_ecom_loading:{
                    standard_methods_data:false,
                    pro_methods_data:false
                }
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if (!vm.isOpenApplication){
                    vm.$router.push({ path: `/application/view/${vm.$route.params.application_reference}/trading/`})
                }

                    if (vm.outlet.trading.contact_title == '' || vm.outlet.trading.contact_title == 'other') {
                    //do nothing
                    }else{
                        vm.setOtherTitle(vm.outlet.trading);
                    }
            })
        },
        beforeRouteLeave(to, from, next) {
            // if(this.abortRouteLeave){
            //     next();
            //     return; //prevent it from doing anything else
            // }

            if(!this.checkDestinationRoute(to, from)){ //if user is going backwards, don't validate
                if (this.pageHasData() && !this.disable_go_back_warning_modal) {
                    this.alertBackRouteWarning((doCall = true) => next(doCall))
                } else {
                    next()
                    return;
                }
            }else{
                 if (!this.isOpenApplication){
                     next(true);
                 } else {
                     if (to.fullPath.includes('edit')) {
                         // If open application do validate and save
                         this.saveOutlet(() => {next()});
                     } else {
                         next(true)
                     }
                 }
           }
        },
        metaInfo() {
            return {
                title: this.lang('trading_details')
            }
        },
        computed: {
            outlet_id: function () {
                return this.$route.params.outlet_ref;
            },
            legal_name() {
                return this.merchant.hasOwnProperty('legal_name') ? (this.merchant.legal_name) : '';
            },
            registered_address() {
                return this.merchant.hasOwnProperty('registration_address') ? new Contact(this.merchant.registration_address) : {};
            },
            outlet: function () {
              return this.outlets[0];
            },
            paymentBeforeDeliveryAccepted: function () {
                return this.outlet.has_full_pmnt_bef_del === '1'
            },
            depositRequired: function () {
                return this.outlet.deposit_flag == '1'
            },
            merchantHasTradeName: function (){
                return this.merchant.trade_name !== '';
            },
            allianceCountry: function() {
                return defaultCountry;
            },
            outletIsEcom: function (){
                return this.outlet.payment_method === this.payment_method.PAYMENT_METHOD_ECOM_ONLY
            },
            showOnMotoAndIsEcom: function (){
                //TODO detemine whether to use quote or outlet as source of truth
                //this uses outlet.payment_method  this.outletIsEco
                //console.log('quote', this.quote, 'outlet', this.outlet)
                let payment_method = this.payment_method.PAYMENT_METHOD_ECOM_ONLY
                return (this.outlet.payment_method === payment_method || this.outlet.sales_moto_perc > 10 )
            },
            isLargeMoto: function (){
                return this.outlet.sales_moto_perc > 10;
            },
            can_process_german_ecom_payment: function () {
                return (this.outlet.sales_internet_perc > 0 && this.allianceCountry === '276')
            },
            // isBlendedMid: function () {
            //   let vm = this;
            //   if (!vm.hasTenantAppDefaults)
            //     return false;
            //
            //   let is_blended_mid = vm.parameters.TENANT_APP_DEFAULTS_PARAM.find(data => {
            //     if (data['field_name'] === 'blended_mids_off'  && data['default_value'] === '0'){
            //       return true;
            //     }
            //   });
            //
            //   return !!is_blended_mid;
            // },
        },
        mounted() {
            this.pageConfig = this.page_config[this.page_config_template];

            let vm = this;

            if (vm.outlet.hasOwnProperty('trading') && vm.outlet.trading.hasOwnProperty('email_address')
                && !!vm.outlet.trading.email_address) {
                vm.outlet.business_email_address = vm.outlet.trading.email_address;
            }
            useModuleStore().commit(types.TOGGLE_LOADING, true);
            setTimeout(function () {
                vm.runPageConfig(vm.page_config[vm.page_config_template]);
                vm.updateDisplayBlockTransactions();
                useModuleStore().commit(types.TOGGLE_LOADING, false);
                $("#form").formValidator({
                    // triggerElement: '', //trigger element default $('form').find('button[type="submit"]')
                    triggerEvent: '', // event - default 'click'
                    defaultConfig: '', // {} - object to set different configuration in validate.js
                    scrollToError: '', // enable auto-scroll to invalid element default true expect boolean
                    additionalCallbackFunction: '',
                });
            }, 1000);

            setTimeout(function (){
              if (vm.outlet.trading.contact_title == '' || vm.outlet.trading.contact_title == 'other') {
                //do nothing
              }else{
                vm.setOtherTitle(vm.outlet.trading);
              }
            }, 3000)
            // if (this.outlet.trading.contact_title !== '') {
            //     this.setOtherTitle(this.outlet.trading);
            // }
            this.country_code_params = this.getCountryCodeParams(this.app_default_param.ENTITY_BLOCK_ALL_OUTLET, this.app_default_param.COUNTRY_CODE);
        },
        methods: {
            goBack: function (){
                this.abortRouteLeave = true;
                this.$router.push({path:  this.application_root_path +'business_details/'})
            },
            doContinue: function (){
                let vm = this;
                let path_to = this.application_root_path + 'business_details/principals/';
                    vm.$router.push({path: path_to})
            },
            pageHasData: function (){
                return this.formHasValues($('#form'))
            },
            getStoreAddressFinderStructureByIso3: function (iso3) {
                if (this.store_address_finder_structure.hasOwnProperty(iso3)) {
                    return this.store_address_finder_structure[iso3];
                } else {
                    return this.store_address_finder_structure.default;
                }
            },
            saveOutlet: function (callback = null) {
                let vm = this;
                if (vm.validateOutlet()) {
                    let payload = this.outlets[0];
                    let form = this.getFormData($('#form'));
                    payload.section = form.section;
                    payload.prod_serv_sold = objCommon.base60_encode(payload.prod_serv_sold);
                    vm[types.SAVE_OUTLET](payload).then(response => {
                        if (response.data.result === 'SUCCESS') {
                            vm.notifySuccess(vm.lang('trading_details_updated_successfully'));
                            if (vm.is_reviewing) {
                              vm.$emit('close_review_section');
                            }

                            if (!!callback) { //call back is the next function in nav guard
                                callback();
                            }
                        }
                    }).catch(error => {
                        //console.log(error)
                    })
                }
            },
            validateOutlet: function () {
                const form_is_valid = this.validateForm('#form');
                let form = this.getFormData($('#form')), section = form.section;

                let is_valid_address = this.addressIsValid(this.outlets[0].trading);

                if (!is_valid_address) {
                    if (this.countCharacters(this.outlets[0].trading.house_name) === 0 && this.countCharacters(this.outlets[0].trading.house_number) === 0) {
                        this.setHasErrorClassOnField(['house_name', 'house_number'])

                        this.notifyError(this.lang('validation_error'), this.lang('validation_house_name_number_is_required'))
                    }

                    this.notifyError(this.lang('validation_error'), this.lang('validation_postcode_search'));
                    return false;
                }
                if (this.outlet.ecom_payment_methods && this.outlet.ecom_payment_methods.hasOwnProperty('selected_standard_methods')
                        && this.outlet.ecom_payment_methods.selected_standard_methods.length > 3) {
                    this.notifyError(this.lang('validation_error'), this.lang('validation_ecom_payment_methods'));
                    return false;
                }

                return form_is_valid
            },
            changeTradingAddress: function (){
                this.outlet['store_address_same_as_registered_address'] = '0';
                this.changedPostcode(this.outlet.trading)
            },
            changeAddressFinderTradingAddress: function (){
                this.outlet['store_address_same_as_registered_address'] = '0';
            },
            formatTradeContact: function (trading, single_line = false){
                let fullContact = '';
                let is_contact = false;
                let separator = '';
                if (!single_line) {
                    separator = '<br/>';
                } else {
                    separator = ',&nbsp';
                }

                let keyMap = ['contact_title', 'other_contact_title', 'contact_first_name', 'contact_second_name', 'contact_last_name', 'email_address', 'ent_telephone_code', 'telephone_number'];
                keyMap.some((obj) => {
                    if (trading.hasOwnProperty(obj) && trading[obj] !== '') {
                        is_contact = true;
                    }
                });

                if (is_contact) {
                    fullContact += trading.contact_title === 'other' ? trading.other_contact_title : trading.contact_title + ' ';
                    fullContact += trading.contact_first_name === '' ? '' : trading.contact_first_name + ' ';
                    fullContact += trading.contact_last_name === '' ? '' : trading.contact_last_name + separator;
                    fullContact += trading.email_address === '' ? '' : trading.email_address + separator;
                    fullContact += trading.ent_telephone_code === '' ? '' : this.formatPhoneCode(trading.ent_telephone_code);
                    fullContact += trading.telephone_number === '' ? '' : trading.telephone_number + separator;
                    fullContact = fullContact === '' ? '-' : fullContact;
                } else {
                    fullContact = "-";
                }
                return fullContact;
            },
            copyBusinessInfo: function (val, infoObject){
                let keyMap = ['trade_name', 'website'];
                let vm = this;
                if(val === '1') {
                    keyMap.forEach((obj) => {
                      let value = !!vm.merchant[obj] ? vm.merchant[obj] : !!vm.quote[obj] ? vm.quote[obj] : '';

                      //if trade_name is not there,  copy legal name
                      if (obj === 'trade_name' && value === ''){
                        value = !!vm.merchant['legal_name'] ? vm.merchant['legal_name'] : !!vm.quote['legal_name'] ? vm.quote['legal_name'] : '';
                      }

                      if(value !== '') {
                          infoObject[obj] = value;
                      }

                    });
                    this.runValidationOnFieldChange(keyMap);
                }
            },
            copyBusinessContact: function (val, contactObject) {
                let keyMap = ['contact_title', 'contact_first_name', 'contact_second_name', 'contact_last_name', 'email_address', 'ent_telephone_code', 'telephone_number'];
                let vm = this;
                let empty_fields = [];

                //ensure that every required field  is set else  throw error.
                if(val === '1') {
                    keyMap.forEach((obj) => {
                        let value = !!vm.merchant[obj] ? vm.merchant[obj] : !!vm.quote[obj] ? vm.quote[obj] : '';

                        //check the contact_title and other_contact_title logic
                        if (obj === 'contact_title' && value !== '') {
                          let title = this.primeTitles.find(obj => {return obj.id === value});

                          //check if the value is part of the prime titles in the radios.
                          if (!title){
                            contactObject['contact_title'] = 'other';
                            contactObject['other_contact_title'] = value;
                          }else{
                              contactObject['contact_title'] = value;
                          }
                        } else if (value === '') {
                          empty_fields.push(obj.replace(/_/g, " "));
                        } else {
                          contactObject[obj] = value;
                        }
                    });

                    //if a copied field is empty throw error and open the fields for editing
                    if (empty_fields.length > 0){
                        // this.notifyError('Copy details are incomplete', 'These fields are empty: ' +  empty_fields.join(', '))
                        this.outlet.store_contact_same_as_business_contact = '0';
                    }
                    this.runValidationOnFieldChange(keyMap);
                }

                //commented out to allow the user edit the values
                // else{
                //
                //     keyMap.forEach((obj) => {
                //         contactObject[obj] = '';
                //     });
                // }

            },
            copyRegisteredAddress: function (val, addressObject) {
                let keyMap = ['zip_code', 'flat_name', 'flat_number', 'house_name', 'house_number', 'street_line_1', 'city', 'county_code', 'country_code'];
                let vm = this;
                let empty_fields = [];

                if(val === '1') {
                    keyMap.forEach((obj) => {
                        let value  = !!vm.registered_address[obj] ? vm.registered_address[obj] : '';
                        if(value === ''){
                            empty_fields.push(obj.replace(/_/g, " "));
                        }

                        if (value !== '') {
                            addressObject[obj] = value;
                        }
                    });

                    //if a copied field is empty throw error and open the fields for editing
                    if (empty_fields.length > 0){
                        // this.notifyInfo('Copy details are incomplete', 'These fields are empty: ' +  empty_fields.join(', '))
                        this.outlet.store_address_same_as_registered_address = '0';
                    }
                    this.runValidationOnFieldChange(keyMap);
                }
                //don't empty address
                // else{
                //     keyMap.forEach((obj) => {
                //         let value = '';
                //         if (obj === 'country_code'){
                //             value = '826'
                //         }
                //         addressObject[obj] = value;
                //     });
                // }

            },
            updateEcomPaymentMethod: function (method_group_type, event) {
                let method_list = [...event];
                if (this.can_process_german_ecom_payment) {
                    this.is_ecom_loading[method_group_type] = true
                    setTimeout(() => {

                        let method_group_data = this.outlet.ecom_payment_methods[method_group_type];

                        if (method_list.includes('paypal_MID') && !method_list.includes('paypal_address')) {
                            method_list.push('paypal_address');
                        } else {
                            method_list = method_list.filter(method => method !== 'paypal_address');
                        }
                        method_group_data = method_group_data.filter(method => method_list.includes(Object.keys(method)[0]));
                        for (let i = 0; i < method_list.length; i++) {
                            let methodExists = method_group_data.some(method => Object.keys(method)[0] === method_list[i]);
                            if (!methodExists) {
                                let newMethod = {[method_list[i]]: ''};
                                method_group_data.push(newMethod);
                            }
                        }

                        let ecom_payment_methods = {
                            ...this.outlet.ecom_payment_methods,
                            [method_group_type]: method_group_data
                        };
                        this.$set(this.outlet, 'ecom_payment_methods', ecom_payment_methods);
                        this.is_ecom_loading[method_group_type] = false
                    }, 1000)
                }
            },

            updateAddress: function (data, target) {

                let keyMap = {
                    zip_code: 'postcode',
                    house_name: 'buildingName',
                    house_number: 'buildingNumber',
                    street_line_1: 'street',
                    locality: 'locality',
                    city: 'city',
                    county_code: 'county',
                };
                Object.entries(keyMap).forEach(([key, value]) => {
                    target[key] = data[value];
                });
                target['country_code'] = this.baseCountryCode;
            },
            updateDisplayBlockTransactions: function () {
                let block_transactions = ['sales_ftf_perc', 'sales_moto_perc', 'sales_internet_perc'];
                this.show_block_transactions_heading = block_transactions.some(ref => ($('#'+ref).length > 0 && $('#'+ref).attr('type') !== 'hidden'));
            },
        },
        watch: {
            'outlet.trading.email_address': {
                immediate: true,
                handler: function (val) {
                    this.outlet.business_email_address = val;
                }
            }
        },
    }
</script>

<style scoped>

</style>
